// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1bu9X","text":"SelectPayment_text__REfBg","title":"SelectPayment_title__1ZsRq","btn":"SelectPayment_btn__1ilfw"};